module.exports = __webpack_public_path__ + "img/help-step-3.4bf2d88e.png";